import { RiskLevel } from '@sparling/financial-common'
import { createEnum } from '../utils/createEnum'

export const riskScoreTypes = [
  {
    value: 'Client risk score',
    label: 'Client risk score',
  },
  {
    value: 'KYT risk score',
    label: 'KYT risk score',
  },
]

export const riskScoreOperators = [
  {
    value: 'equal to',
    label: 'equal to',
  },
]

export const finalRiskScoreTypes = [
  {
    value: 'Client risk score',
    label: 'Client risk score',
  },
  {
    value: 'Final transaction risk score',
    label: 'Final transaction risk score',
  },
]

export const riskScoreLevels = createEnum(Object.values(RiskLevel))
